import React from 'react';
import SpaceUsageItemsList from "../SpaceUsageItemsList";
import Pagination, { IPagination } from "../deprecatedUikit/Pagination/Pagination";
import type { BookedSpaceCalendarView } from "../../types/BookedSpaceCalendarView";
import { Grid } from "@mui/material";

interface SpaceUsageItemsPaginatedProps {
  spaceUsageItems: BookedSpaceCalendarView[];
  count: number;
  rowsPerPage: number;
  page: number;
  onRowsPerPageChange: IPagination['onRowsPerPageChange'];
  onPageChange: IPagination['onPageChange'];
  onViewOverageInvoices: () => void;
}

/** Paginated list of space usage items */
const SpaceUsageItemsPaginated = (props: SpaceUsageItemsPaginatedProps) => {
  const { spaceUsageItems, count, page, rowsPerPage, onRowsPerPageChange, onPageChange, onViewOverageInvoices } = props;

  return (
    <Grid item container rowGap={'2rem'} component={'section'}>
      <SpaceUsageItemsList spaceUsageItems={spaceUsageItems} onViewOverageInvoices={onViewOverageInvoices} />
      <Grid sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
      }}>
        <Pagination
          onPageChange={onPageChange}
          count={count}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={onRowsPerPageChange}
          page={page}
          variant={'tablePagination'}
          scrollToBottomOnPageChange={true}
        />
      </Grid>
    </Grid>
  );
};

export default SpaceUsageItemsPaginated;
